<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';

const route = useRoute();
const { t } = useI18n();
const { accountScopedRoute } = useAccount();

const reportItems = computed(() => [
  {
    key: 'overview',
    label: t('SIDEBAR.REPORTS_OVERVIEW'),
    to: accountScopedRoute('account_overview_reports'),
    activeOn: ['account_overview_reports'],
  },
  {
    key: 'conversations',
    label: t('SIDEBAR.REPORTS_CONVERSATION'),
    to: accountScopedRoute('conversation_reports'),
    activeOn: ['conversation_reports'],
  },
  {
    key: 'agents',
    label: t('SIDEBAR.REPORTS_AGENT'),
    to: accountScopedRoute('agent_reports_index'),
    activeOn: ['agent_reports_index', 'agent_reports_show'],
  },
  {
    key: 'labels',
    label: t('SIDEBAR.REPORTS_LABEL'),
    to: accountScopedRoute('label_reports_index'),
    activeOn: ['label_reports_index', 'label_reports_show'],
  },
  {
    key: 'inboxes',
    label: t('SIDEBAR.REPORTS_INBOX'),
    to: accountScopedRoute('inbox_reports_index'),
    activeOn: ['inbox_reports_index', 'inbox_reports_show'],
  },
  {
    key: 'teams',
    label: t('SIDEBAR.REPORTS_TEAM'),
    to: accountScopedRoute('team_reports_index'),
    activeOn: ['team_reports_index', 'team_reports_show'],
  },
  {
    key: 'csat',
    label: t('SIDEBAR.CSAT'),
    to: accountScopedRoute('csat_reports'),
    activeOn: ['csat_reports'],
  },
  {
    key: 'campaigns',
    label: t('SIDEBAR.REPORTS_CAMPAIGNS'),
    to: accountScopedRoute('campaign_reports'),
    activeOn: ['campaign_reports'],
  },
  {
    key: 'sla',
    label: t('SIDEBAR.REPORTS_SLA'),
    to: accountScopedRoute('sla_reports'),
    activeOn: ['sla_reports'],
  },
  {
    key: 'bot',
    label: t('SIDEBAR.REPORTS_BOT'),
    to: accountScopedRoute('bot_reports'),
    activeOn: ['bot_reports'],
  },
]);

const isActive = item => item.activeOn.includes(route.name);
</script>

<template>
  <div
    class="reports--wrapper h-full min-h-0 w-full overflow-y-auto overflow-x-hidden bg-n-surface-1 px-4 sm:px-6"
  >
    <nav
      class="sticky top-0 z-20 -mx-4 mb-5 border-b border-n-weak bg-n-surface-1/95 px-4 backdrop-blur sm:-mx-6 sm:px-6"
      :aria-label="t('SIDEBAR.REPORTS')"
    >
      <div class="flex min-w-0 items-center gap-1 overflow-x-auto py-2">
        <RouterLink
          v-for="item in reportItems"
          :key="item.key"
          :to="item.to"
          class="whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium text-n-slate-11 transition-colors hover:bg-n-alpha-2 hover:text-n-slate-12"
          :class="{
            'bg-n-blue-3 text-n-blue-11': isActive(item),
          }"
        >
          {{ item.label }}
        </RouterLink>
      </div>
    </nav>
    <div class="w-full max-w-[96rem] mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>
